// extracted by mini-css-extract-plugin
export default {"ProductListWrapper":"ProductList_ProductListWrapper__EXcLq"};